<template>
    <div class="cards boxShadow transitionStyle">
        
        <div class="cards-name flex" @click="gotoDetail(datas.id)">
            <img :src="datas.headSculptureUrl" alt="" class="shrink">
            <div class="cards-name-company textOver">
                <p class="textOver shrink">{{ datas.nameCn }}</p>
                <div class="flex flexWarp"> 
                    <span> {{datas.industryTypeName}} / </span>
                    <span> {{datas.financingTypeName}} / </span>
                    <span> {{datas.companyTypeName}}</span> 
                </div>
            </div>
        </div>
        <div class="cards-info flexBetween">
           <div class="flexColumn">
                <p><span>{{datas.recruittingPositionCounts}}</span> 个</p>
                <p>在招职位</p>
           </div>
           <div class="flexColumn">
                <p> <span>{{datas.browseCounts}}</span></p>
                <p>浏览量</p>
           </div>
           <div class="flexColumn">
                <p> <span>{{ datas.feedbackDays }}</span> 天</p>
                <p>反馈时间</p>
           </div>

        </div>
    </div>
  </template>
  
  <script>

  export default {
    props: {
        datas:{
            type:Object,
            default:()=>{}
        }
    },
    data() {
      return {
     };
    },
    components: {
        
    },
    methods: {
        gotoDetail(id){
            window.open(`/company/detail?id=${id}`);
        },
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
.cards {
   
    background-color: $whiteColor;
    width: 302px;
    padding: 24px 12px;
    margin-bottom: 24px;
    &:not(:nth-child(4n)){
        margin-right: 24px;
    }
    &:hover{
        box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, 0.3);
    }
    &-name{
        cursor: pointer;
        img{
            width: 56px;
            height: 56px;
            border-radius: 4px;
            overflow: hidden;
            margin-right: 10px;
        }
        p{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #000000;
            line-height: 22px; 
            padding-top: 6px;
            padding-bottom: 4px;
        }
        span{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: $secondfontCol;
            line-height: 20px;

        }
    
    }
    &-info{
        padding: 18px 10px 0;
        border-top: 1px solid #D8D8D8;
        margin-top: 18px;
        p{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: $secondfontCol;
            span{
                font-size: 18px;
                font-family: Arial-BoldMT, Arial;
                font-weight: normal;
                color: #000000;
            }
        }
       
    }
  }
  </style>
  